module.exports = __webpack_public_path__ + "img/section20.3a018f1c.png";